export { default as LoginView } from "./LoginView";
